import { render, staticRenderFns } from "./StartCertificationCard.vue?vue&type=template&id=bfb1e39a&scoped=true&"
import script from "./StartCertificationCard.vue?vue&type=script&lang=ts&"
export * from "./StartCertificationCard.vue?vue&type=script&lang=ts&"
import style0 from "./StartCertificationCard.vue?vue&type=style&index=0&id=bfb1e39a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb1e39a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow})
